import CookiesStorageService from './CookiesStorageService'
import AppRoutes from './AppRoutes'

const getRequiredAuthRedirect = () => {
  if (CookiesStorageService.getIsFirstLogin()) {
    return AppRoutes.firstTimePassword
  }

  if (!CookiesStorageService.isAcceptedPolicies()) {
    return AppRoutes.consent
  }

  return null
}

export default getRequiredAuthRedirect
